import {differenceInCalendarDays, format, isValid, parseISO, startOfDay} from "date-fns";

// The Admin app shows German formats regardless of UI language: operators read invoices and Stripe data in them.
const euroAmount = new Intl.NumberFormat("de-DE", {minimumFractionDigits: 2, maximumFractionDigits: 2});
const count = new Intl.NumberFormat("de-DE", {maximumFractionDigits: 0});
const oneDecimal = new Intl.NumberFormat("de-DE", {maximumFractionDigits: 1});

const BYTES_PER_MEGABYTE = 1024 * 1024;
const MEGABYTES_PER_GIGABYTE = 1024;

function parseDate(value: string | undefined | null): Date | null {
    if (!value) return null;
    const date = parseISO(value);
    return isValid(date) ? date : null;
}

/** `dd.MM.yyyy` for a calendar day (`yyyy-MM-dd`) or an ISO instant; `-` when absent or unparseable. */
export function formatDate(value: string | undefined | null): string {
    const date = parseDate(value);
    return date ? format(date, "dd.MM.yyyy") : "-";
}

export function formatDateTime(value: string | undefined | null): string {
    const date = parseDate(value);
    return date ? format(date, "dd.MM.yyyy HH:mm") : "-";
}

export function formatEuroCents(cents: number): string {
    return `${euroAmount.format(cents / 100)} €`;
}

export function formatCount(value: number): string {
    return count.format(value);
}

export function formatStorageBytes(bytes: number): string {
    const megabytes = bytes / BYTES_PER_MEGABYTE;
    if (megabytes >= MEGABYTES_PER_GIGABYTE) {
        return `${oneDecimal.format(megabytes / MEGABYTES_PER_GIGABYTE)} GB`;
    }
    return `${oneDecimal.format(megabytes)} MB`;
}

/** Whole calendar days from `now` to `day` (`yyyy-MM-dd`); negative once the day has passed. */
export function calendarDaysUntil(day: string, now: Date): number {
    return differenceInCalendarDays(startOfDay(parseISO(day)), startOfDay(now));
}
